






































import Vue from 'vue';
import {mapActions, mapGetters} from 'vuex';
import {MyProfileAPI} from '#/User';
import {TranslateResult} from 'vue-i18n';
import {VForm} from '#/index';

interface ComponentData {
  alert: {
    displayed: boolean;
    message: string;
    type: 'info' | 'error';
  };
  email: {
    validation: boolean;
    value: string;
  };
  message: boolean;
  ernest: boolean;
  rules: ((v: string) => boolean | TranslateResult)[];
}

export default Vue.extend({
  name: 'Notifications',

  data(): ComponentData {
    return {
      alert: {
        displayed: false,
        message: '',
        type: 'info',
      },
      email: {
        validation: false,
        value: '',
      },
      message: false,
      ernest: false,
      rules: [
        (v: string) => !!v || this.$t('profile.notifications.errors.required'),
        (v: string) => /^[a-z0-9-_.]+@[a-z0-9-_.]+\.[a-z]{2,}$/.test(v) || this.$t('profile.notifications.errors.format'),
      ],
    };
  },

  computed: {
    ...mapGetters([
      'profile',
    ]),
  },

  created() {
    this.loadProfile()
        .then(() => {
          this.email.validation = this.profile.useEmailNotification;
          this.email.value = this.profile.email;
          this.ernest = this.profile.useErnestNotification;
          this.message = this.profile.useMessageNotification;
        });
    this.updatePageTitle(this.$t('template.sideMenu.notifications'));
  },

  methods: {
    ...mapActions([
      'displaySnackBar',
      'loadProfile',
      'updatePageTitle',
      'updateProfile',
    ]),
    onToggleCheckboxValue(newValue: boolean): void {
      if (newValue) {
        if (this.profile.email) {
          this.email.value = this.profile.email;
          this.email.validation = newValue;
          return;
        }
        const jwt = localStorage.getItem('JWT__access__token');
        if (jwt) {
          const {mail} = JSON.parse(window.atob(jwt.split('.')[1] as string));

          this.email.value = mail || '';
          this.email.validation = newValue;
          return;
        }
      }

      this.email.value = '';
      this.email.validation = newValue;
    },
    onValidNewSettings(): void {
      if ((this.$refs.notificationForm as VForm).validate()) {
        const user: MyProfileAPI = {
          ...this.profile,
          useEmailNotification: this.email.validation,
          useErnestNotification: this.ernest,
          useMessageNotification: this.message,
          email: this.email.validation ? this.email.value : '',
        };

        this.updateProfile(user)
            .then((user: MyProfileAPI) => {
              (this.$refs.notificationForm as VForm).resetValidation();
              this.email.validation = user.useEmailNotification;
              this.email.value = user.email;
              this.ernest = user.useErnestNotification;
              this.message = user.useMessageNotification;

              this.alert.type = 'info';
              this.alert.message = this.$t('profile.notifications.message') as string;
              this.alert.displayed = true;
            })
            .catch(() => {
              this.alert.type = 'error';
              this.alert.message = this.$t('profile.notifications.errors.general') as string;
              this.alert.displayed = true;
            });
      }
    },
  },
});
